import v4 from 'uuid/v4';
import moment from 'moment';
import GraduacionesClienteEncargoBuilder from './GraduacionesClienteEncargoBuilder.creador';

export default class EncargoSimpleBuilder {
  static build(datos) {
    const { gestorId } = datos;
    const uuid = datos.uuid ? datos.uuid : v4();
    const fechaCreacion = moment();
    const fechaCreacionPretty = fechaCreacion.format('DD/MM/YYYY [a las] h:mm');
    return {
      id: null,
      expandido: false,
      uuid: uuid,
      nombre: 'Encargo simple',
      cabecera: {
        fechaCreacion,
        fechaCreacionPretty,
        fechaEntrega: moment(),
        tipoEncargoId: null,
        cliente: {
          id: null,
          nombreCompleto: null,
          tiendaId: null,
          graduaciones: GraduacionesClienteEncargoBuilder.build({ mostrar: false }),
        },
        motivoVisitaId: null,
        gestorId,
        numeroTalon: null,
        observaciones: null,
        tarjetaFidelizacion: {
          id: null,
          contenido: null,
        },
      },
      detalles: [],
      detallesTemporales: [],
      erroresFormulario: {},
    };
  }
}
